import heart from '../asset/images/heart.svg'
import { useState, useEffect } from 'react';

import { getAbout } from '../firebase';
import { useDarkMode } from "../DarkModeContext";
export default function About() {

    const { darkMode, toggleDarkMode } = useDarkMode();

    const [dataAbout, setDataAbout] = useState()
    const [textAbout, setTextAbout] = useState()
    const [avatar, setAvatar] = useState()
    const [coordiante, setCoordinate] = useState()
    const [listEx, setSetListEx] = useState()
    const [listHob, setListHob] = useState()


    useEffect(() => {
        const fetchData = async () => {
            try {
                const aboutData = await getAbout();
                setDataAbout(aboutData);

                console.log(dataAbout);

                const aboutMeText = aboutData[0].aboutme;
                setTextAbout(aboutMeText);

                const avataror = aboutData[0].avatar
                setAvatar(avataror)

                const coordiante = aboutData[0].coordiante
                setCoordinate(coordiante)


                const listE = aboutData[0].listEx
                setSetListEx(listE)

                const listH = aboutData[0].listHob
                setListHob(listH)


            } catch (error) {
                console.error('Error fetching about data:', error);
            }
        };

        fetchData();
    }, []);
    const iframeStyles = {
        border: '0',
        width: '600px',
        height: '450px',
    };
    return (
        <div className="about">
            <div className="about-right">
                <div className="about-right_above">
                    <div className={darkMode ? "about-right_above-desc-dark" : "about-right_above-desc"}>
                        <div className="about-right_above-title">
                            <h1>About me</h1>
                        </div>
                        <div className="about-right_about-icon">
                            <img src={heart} alt="" />
                        </div>
                        <div className="about-right_above-content">
                            {textAbout ? (<p>
                                {textAbout ? textAbout : 'Đang tải........'}
                            </p>) : (<div className="loading-indicator-container">
                                <div className="loading-indicator"></div>
                            </div>)}

                        </div>
                    </div>
                    <div className="about-right_above-avartar">
                        {avatar ? (<img src={avatar ? avatar : ''} alt="" />) : (<div className="loading-indicator-container">
                            <div className="loading-indicator"></div>
                        </div>)}

                    </div>
                </div>

                <div className="about-right_bottom">
                    <div className="about-right_bottom-map">
                        {coordiante ? (<iframe
                            src={coordiante ? coordiante : 'Đang load...'}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title='Embedded Content'
                        />) : <div className="loading-indicator-container">
                            <div className="loading-indicator"></div>
                        </div>}
                    </div>
                    <div className={darkMode ? "about-right_bottom-hobbies-dark" : "about-right_bottom-hobbies"}>
                        <div className="wrap-hobbies">
                            <h1>Hobbies</h1>
                            <div className="wrap-hobby">
                                {listHob ? (listHob.map((data, index) => (
                                    <div key={index}>{data.nameHB}</div>
                                ))) : <div className="loading-indicator-container">
                                    <div className="loading-indicator"></div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={darkMode ? "about-left-dark" : "about-left"} >
                <div className="about-left-title">
                    <h1>Experience</h1>
                    <div className="about-left-container">

                        {listEx ? (
                            listEx.map((data, index) => (
                                <div key={index} className="about-left-container_item">
                                    <h3 className="title-skill">
                                        {data.nameEx}:
                                    </h3>
                                    <div className="name-skill-ex">
                                       {data.nameDescEx}
                                    </div>
                                </div>
                            ))
                        ) : (<div className="loading-indicator-container">
                            <div className="loading-indicator"></div>
                        </div>)}

                    </div>
                </div>
            </div>
        </div>
    )
}